import { Button, FieldWrapper, Label } from '@commenda/kakashi';
import { TSysAgentStepDefinition, TValueProvider } from '@commenda/types';

import { extractUrlVariables } from '../../../workflow/workflow-templates/validation';
import { TPromptKey, TPromptMappingKey } from '../../types/node';

const PROMPT_FIELDS: {
  key: TPromptKey;
  mappingKey: TPromptMappingKey;
  label: string;
}[] = [
  {
    key: 'systemPrompt',
    mappingKey: 'systemPromptValueMapping',
    label: 'System prompt',
  },
  { key: 'userPrompt', mappingKey: 'userPromptValueMapping', label: 'Task' },
];

interface AgentPromptVariablesFieldProps {
  selectedStep: TSysAgentStepDefinition;
  onVariableEdit: (variable: string, mappingKey: TPromptMappingKey) => void;
}

export const bindingsForMappingKey = (
  selectedStep: TSysAgentStepDefinition,
  mappingKey: TPromptMappingKey
): Record<string, TValueProvider> => selectedStep[mappingKey] ?? {};

export const AgentPromptVariablesField = ({
  selectedStep,
  onVariableEdit,
}: AgentPromptVariablesFieldProps) => (
  <>
    {PROMPT_FIELDS.map(({ key, mappingKey, label }) => {
      const variables = extractUrlVariables(selectedStep[key] ?? '');
      if (variables.length === 0) return null;

      const bindings = bindingsForMappingKey(selectedStep, mappingKey);
      const missing = variables.filter((variable) => !bindings[variable]);

      return (
        <FieldWrapper key={mappingKey}>
          <Label>{label} variables</Label>
          <div className="flex flex-col gap-xs">
            {variables.map((variable) => (
              <div
                key={variable}
                className="flex items-center justify-between gap-md"
              >
                <span className="txt-small-regular text-text-primary">
                  {`{{${variable}}}`}
                </span>
                <Button
                  variant="tertiary"
                  size="sm"
                  onClick={() => onVariableEdit(variable, mappingKey)}
                >
                  {bindings[variable] ? 'Edit binding' : 'Bind value'}
                </Button>
              </div>
            ))}
          </div>
          {missing.length > 0 && (
            <p className="txt-extra-small-regular text-text-error mt-xs">
              Missing binding for: {missing.join(', ')}
            </p>
          )}
        </FieldWrapper>
      );
    })}
  </>
);
